export function fromMillisecondsToSeconds(timeInMilliseconds: number): number {
  return Math.floor(timeInMilliseconds / 1000)
}
